import { AZURE_ACTIVE_DOMAIN } from "../config/globalVariables";
import { PublicClientApplication } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: AZURE_ACTIVE_DOMAIN.appId,
    authority:
      "https://login.microsoftonline.com/" + AZURE_ACTIVE_DOMAIN.tenant,
    redirectUri: AZURE_ACTIVE_DOMAIN.redirectUri,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);
await msalInstance.initialize();

export async function getAccessToken() {
  if (!msalInstance) {
    throw new Error("MSAL instance is not initialized");
  }
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    const result = await msalInstance.acquireTokenSilent({
      scopes: ["Calendars.ReadWrite"],
      account: accounts[0],
    });
    return result.accessToken;
  } else {
    const result = await msalInstance.loginPopup({
      scopes: ["Calendars.ReadWrite"],
    });
    return result.accessToken;
  }
}

export const apiConfig = {
  resourceScopes: AZURE_ACTIVE_DOMAIN.scopes,
};

export const loginRequest = {
  scopes: ["openid", "profile", "offline_access", ...apiConfig.resourceScopes],
  prompt: "select_account",
};

export const silentRequest = {
  scopes: [...apiConfig.resourceScopes],
};
export const tokenRequest = {
  scopes: [...apiConfig.resourceScopes],
};
